function getErrorMessage(error) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var defaultMessage = 'Something went wrong. Please contact support.';
    if (!error)
        return defaultMessage;
    var errorMsg = (_f = (_e = (_d = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.graphQLErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.extensions) === null || _c === void 0 ? void 0 : _c.exception) === null || _d === void 0 ? void 0 : _d.invalidArgs) === null || _e === void 0 ? void 0 : _e[0].message) !== null && _f !== void 0 ? _f : null;
    if (errorMsg)
        return errorMsg;
    errorMsg = (_j = (_h = (_g = error === null || error === void 0 ? void 0 : error.graphQLErrors) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.message) !== null && _j !== void 0 ? _j : null;
    if (errorMsg)
        return errorMsg;
    errorMsg = (_p = (_o = (_m = (_l = (_k = error.networkError) === null || _k === void 0 ? void 0 : _k.result) === null || _l === void 0 ? void 0 : _l.errors) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.message) !== null && _p !== void 0 ? _p : null;
    if (errorMsg)
        return errorMsg;
    return defaultMessage;
}

export { getErrorMessage };
//# sourceMappingURL=ErrorUtil.js.map
